<template>
  <v-container>
  <v-layout row wrap>

    <v-flex xs12 pa-1>
        <v-card v-if="fundraiserProperties">
            <v-card-title>
                <span class="title"><v-icon>{{fundraiserProperties.fundraisericon}}</v-icon> {{fundraiserProperties.fundraisertitle}} </span>
                <span v-if="fundraiserid ==='endowment'" class="caption">&nbsp; (est. 2014)</span>
            </v-card-title>
            <v-card-text >
                <v-layout row wrap>
                    <v-flex xs12 v-if="fundraiserProperties.showTotals && fundraiserPaymentsGroupedByYearLine">
                        <v-icon>show_chart</v-icon>
                        <span class="title font-weight-black green--text">${{fundraiserPaymentsGroupedByYearLine.grandtotal}}</span> 
                        <span class="body primary--text"> raised so far!</span>
                    </v-flex>
                    <v-flex xs12 v-if="fundraiserProperties.fundraiserdescription" class="caption text--lighten-4">
                        <div v-html="fundraiserProperties.fundraiserdescription"></div>
                    </v-flex>
                </v-layout>
            </v-card-text>
        </v-card>
    </v-flex>

    <v-flex xs12 pa-1>
        <v-card>
            <v-card-title>
                <div class="subheading font-weight-bold"> Am I a subscribed contributor?<span v-if="fundraiserMemberSubscriptionStatusCurrent && fundraiserMemberSubscriptionStatusCurrent.isactive===true" class="green--text">&nbsp;YES</span><span v-else class="red--text">&nbsp;NOT YET</span></div>
                
            </v-card-title>
            <v-card-text v-if="fundraiserMemberSubscriptionStatuses && fundraiserMemberSubscriptionStatuses.length>0">
                <template v-if="fundraiserMemberSubscriptionStatuses.length>0">
                    <v-layout row wrap>
                        <v-flex xs12 >
                            ${{fundraiserMemberSubscriptionStatusCurrent.amount}} <span v-if="fundraiserMemberSubscriptionStatusCurrent.isactive===true" class="green--text subheading font-weight-bold"> -  {{fundraiserMemberSubscriptionStatusCurrent.statustype}}</span> <span v-else class="red--text subheading font-weight-bold"> -  {{fundraiserMemberSubscriptionStatusCurrent.statustype}}</span>
                        </v-flex>
                        <v-flex xs12 class="pt-3">
                            <div  class="flex xs12 caption pl-3" v-bind:key="'vlisttilestatus-' + sind" v-for="(s, sind) in fundraiserMemberSubscriptionStatuses">
                                ${{s.paypaldetails.mc_amount3}} - <b>{{s.transaction_type}}</b> on <em>{{s.paymentdate}}</em>
                            </div>
                        <!--
                        <v-list  >
                            <v-list-tile v-bind:key="'vlisttilestatus-' + sind" class="pb-0 pt-0" v-for="(s, sind) in fundraiserMemberSubscriptionStatuses">
                                <v-list-tile-content class="pb-0 pt-0">
                                    <v-layout class="caption pb-0 pt-0" row wrap>
                                    <v-flex xs12 class="pb-0 pt-0"> 
                                        ${{s.paypaldetails.mc_amount3}} - <b>{{s.transaction_type}}</b> on <em>{{s.paymentdate}}</em>
                                    </v-flex>
                                    </v-layout>
                                </v-list-tile-content>
                            </v-list-tile>
                        </v-list>
                        -->
                                    <v-divider></v-divider>
                        </v-flex>      
                        <template v-if="fundraiserMemberSubscriptionStatusCurrent.isactive===false">
                            <v-flex xs12 pb-3>
                                <v-divider></v-divider>
                            </v-flex>
                            <v-flex xs12 >
                                <div v-html="subscriptionButton"></div>
                            </v-flex>   
                        </template>                                          
                    </v-layout>
                </template>
            </v-card-text>
            <v-card-text v-else>
                <v-layout row wrap>
                        <v-flex xs12  >
                            <span class="red--text subheading font-weight-bold"> <u>Not</u> Yet Subscribed</span>
                        </v-flex>
                        <v-flex xs12 pb-3>
                            <v-divider></v-divider>
                        </v-flex>
                        <v-flex xs12 >
                            <div v-html="subscriptionButton"></div>
                        </v-flex>                        
                </v-layout>
            </v-card-text>
        </v-card>

        <v-card raised class="mt-2"  v-if="fundraiserMemberPayments && fundraiserMemberPayments.length>0">
            <v-card-title>
                <div class="subheading font-weight-bold">My Contributions <span class="caption font-weight-bold"> ({{member.member.toUpperCase().replace('_',', ')}})</span></div>
            </v-card-title>
            <v-card-text>
                <v-layout row wrap>
                <template v-for="(p, indx) in fundraiserMemberPayments">
                <v-flex class="caption pa-1 pt-4 " xs6 :key="`vflexfmbrpmnt-${indx}`"> 
                    <v-layout column>
                    <v-flex grey lighten-4 pa-1> 
                    <span class="primary--text font-weight-bold">${{p.paymentamount}} </span> paid on
                    </v-flex>   
                    <v-flex grey lighten-4 pa-1>
                    {{p.paymentdate}} 
                    </v-flex>                                         

                    </v-layout>
                </v-flex>
                
                </template>
                </v-layout>
            </v-card-text>
        </v-card>
    

        <v-card raised class="mt-2"  v-if="fundraiserPayments && fundraiserPayments.length>0">
            <v-card-title>
                <div class="subheading font-weight-bold">Contributors</div>
            </v-card-title>
            <v-card-text>
                <v-layout row wrap>
                <template v-for="(p, indx) in fundraiserPayments.filter((value, index, self)=>{return self.findIndex(e=>{return e.userid===value.userid})===index})">
                <v-flex class="caption pa-1 pt-4 " xs6 :key="`vflexfpmnt-${indx}`"> 
                    <v-layout column>
                    <v-flex grey lighten-4 pa-1 pb-0> 
                    <span class="primary--text font-weight-bold">{{p.member.toUpperCase().replace('_',', ')}}</span> 
                    </v-flex>   
                    <v-flex grey lighten-4 pa-1 pt-0 >
                    {{p.lineid}} 
                    </v-flex>                                         

                    </v-layout>
                </v-flex>
                
                </template>
                </v-layout>
            </v-card-text>
        </v-card>
    </v-flex>




  </v-layout>
  </v-container>
</template>

<script>
import firebase from 'firebase'
import moment from 'moment'
//import paypal from 'paypal-rest-sdk'

const DATEFORMAT = "ddd, MMM D h:mmA"


const DATEFORMAT_CAMPAIGNS = "YYYY-MM-DD"


import BarChart from './components/BarChart'
import LineChart from './components/LineChart'

  export default {
      data(){
          return{
               fundraiserid: null
          }

      },
    created () {

        //TODO: variablize the entire page to be used for all post types based this.$route.path
        //console.log('.............route.name = ' , this.$route)
        //this.$store.dispatch('loadSortedLinesAndMembers', {chapter: 'zz'})
        //console.log(' this.$route.query.page ' + window.location.href)
        this.fundraiserid = this.$route.path.substring(1)
   
    },      
    computed: {
      user () {
        return this.$store.getters.user
      },
      member () {
        return this.$store.getters.member
      },
      colorMain () {
          return this.$store.getters.colorMain
      },
      allMembers () {
          return this.$store.getters.allMembers
      },
      sortedLinesAndMembers () {
          return this.$store.getters.sortedLinesAndMembers
      },
      memberline () {
          return this.$store.getters.memberLine
      },
      fundraiseridNormalCase(){
          return this.fundraiserid.substring(0,1).toUpperCase() + this.fundraiserid.substring(1)
      },
      fundraiserProperties (){
          if(this.$store.getters.listFundraiserTypes){
            return this.$store.getters.listFundraiserTypes[this.fundraiserid]
          }else{
              return null
          }
          
      },
      fundraiserCampaignsActive (){
          if(this.$store.getters.listFundraiserTypes){
            var campaigns = this.$store.getters.listFundraiserTypes[this.fundraiserid].campaigns
            if(campaigns && campaigns.length>0){
                campaigns = campaigns.filter(c=>{
                    var momStart = moment(c.datestart, DATEFORMAT_CAMPAIGNS)
                    var momEnd = moment(c.dateend, DATEFORMAT_CAMPAIGNS)
                    var rightNow = moment()
                    console.log('moment()',rightNow)
                    console.log('momStart',momStart)
                    console.log('momEnd',momEnd)
                    console.log('rightNow.isBetween(momStart,momEnd)',rightNow.isBetween(momStart,momEnd))
                    


                    if(rightNow.isBetween(momStart,momEnd)){
                    //if(rightNow.isAfter(momStart, 'day') && rightNow.isBefore(momEnd, 'day')){
                        console.log('return true')
                        return true
                    }else{
                        console.log('return false')
                        return false
                    }
                })
            }
            return campaigns
          }else{
              return null
          }
      },      
      fundraiserMemberSubscriptionStatuses () {       
          var rtn = null
          if(this.$store.getters.fundraiserPayments && this.$store.getters.fundraiserPayments[this.fundraiserid]){
              rtn = this.$store.getters.fundraiserPayments[this.fundraiserid].filter(p=>{return p.ispayment===false && p.userid===this.$store.getters.member.userid})
          }     
            return rtn
      },  
      fundraiserMemberSubscriptionStatusCurrent (){
          var rtn =null
          if(this.$store.getters.fundraiserPayments){
            var statuses = this.$store.getters.fundraiserPayments[this.fundraiserid].filter(p=>{return p.ispayment===false && p.userid===this.$store.getters.member.userid})
            if(statuses && statuses.length>0){
                var lastStatus = statuses[statuses.length - 1]
                var rtn= new Object()
                if(lastStatus.transaction_type==="subscr_cancel"){
                    rtn.isactive = false                
                    rtn.statustype = "Subscription Cancelled"
                }else if(lastStatus.transaction_type==="subscr_eot"){
                    rtn.isactive = false
                    rtn.statustype = "Subscription Expired"
                }else if(lastStatus.transaction_type==="subscr_failed"){
                    rtn.isactive = false
                    rtn.statustype = "Subscription Payment Failed"
                }else if(lastStatus.transaction_type==="subscr_modify"){
                    rtn.isactive = true
                    rtn.statustype = "Subscription Active"
                }else if(lastStatus.transaction_type==="subscr_signup"){
                    rtn.isactive = true
                    rtn.statustype = "Subscription Active"
                }

                rtn.amount = lastStatus.paypaldetails.mc_amount3
                rtn.statusdate = lastStatus.paymentdate
                rtn.subscr_id = lastStatus.subscr_id
                
            }
          }
          
          return rtn
      },    
      fundraiserPayments () {      
          var rtn = null
          if(this.$store.getters.fundraiserPayments && this.$store.getters.fundraiserPayments[this.fundraiserid]){
              rtn = this.$store.getters.fundraiserPayments[this.fundraiserid].filter(p=>{return p.ispayment===true})
          }     
            return rtn
      },
      fundraiserPaymentsSorted(){

            if(this.$store.getters.fundraiserPayments && this.$store.getters.fundraiserPayments[this.fundraiserid]){
                var s = this.$store.getters.fundraiserPayments[this.fundraiserid].filter(p=>{return p.ispayment===true}).sort((a,b)=>{if(b.member>a.member){return -1}else{return 1}})
                return s
            }else{
                return null
            }            
            
      },
      fundraiserPaymentsGroupedByYearLine () {
          var rtn = null
          if(this.$store.getters.fundraiserPaymentsGroupedByYearLine && this.$store.getters.fundraiserPaymentsGroupedByYearLine[this.fundraiserid]){
              rtn = this.$store.getters.fundraiserPaymentsGroupedByYearLine[this.fundraiserid]
          }     
            return rtn
      },        
      fundraiserMemberPayments () {
          var rtn = null
          if(this.$store.getters.fundraiserMemberPayments && this.$store.getters.fundraiserMemberPayments[this.fundraiserid]){
              rtn = this.$store.getters.fundraiserMemberPayments[this.fundraiserid].filter(p=>{return p.ispayment===true})            
          }     
          
          return rtn
      },
      fundraiserLinePayments () {
          var rtn = null
          if(this.$store.getters.fundraiserLinePayments && this.$store.getters.fundraiserLinePayments[this.fundraiserid]){
              rtn = this.$store.getters.fundraiserLinePayments[this.fundraiserid].filter(p=>{return p.ispayment===true})
          }    
          
          return rtn
      },
      fundraiserPaymentsGroupedByYearMonth() {
          var rtn = null
          if(this.$store.getters.fundraiserPaymentsGroupedByYearMonth && this.$store.getters.fundraiserPaymentsGroupedByYearMonth[this.fundraiserid]){
              rtn = this.$store.getters.fundraiserPaymentsGroupedByYearMonth[this.fundraiserid]
              //rtn = this.$store.getters.fundraiserPaymentsGroupedByYearMonth[this.fundraiserid].filter(p=>{return p.ispayment===true})
          }    
          
          return rtn
      },     
      paypalnotifyurl(){
        var rtn = "https://us-central1-zzques-staging.cloudfunctions.net/ipnHandlerSubscriptions"
        if(process.env.NODE_ENV==='development' || process.env.NODE_ENV==='staging'){
            rtn = "https://us-central1-zzques-staging.cloudfunctions.net/ipnHandlerSubscriptions"
        }else{
            rtn = "https://us-central1-zzques-2e9f8.cloudfunctions.net/ipnHandlerSubscriptions"  
        }
        return rtn
      },      
      isStaging(){
            var rtn = false
            if(process.env.NODE_ENV==='development' || process.env.NODE_ENV==='staging'){
                rtn = true
            }
            return rtn
      },
      subscriptionButton(){
        var returnurl = window.location.href
        var fundraiserSettings = this.$store.getters.listFundraiserTypes[this.fundraiserid]
        var description = ""
        description = description + this.$store.getters.member.org + "|" //0
        description = description + this.$store.getters.member.chapter + "|" //1        
        description = description + fundraiserSettings.fundraiserid + "|" //2
        description = description + fundraiserSettings.fundraisertitle + "|" //3
        description = description + this.$store.getters.member.userid + "|" //4
        description = description + this.$store.getters.member.member + "|" //5
        description = description + this.$store.getters.member.firstname + "|" //6
        description = description + this.$store.getters.member.lastname + "|" //7   
        description = description + this.$store.getters.member.lineid + "|" //8


        
        
        console.log('description...' + description)
        var valPaypalFormAction = "https://www.paypal.com/cgi-bin/webscr"
        var valNotifyUrl = this.paypalnotifyurl
        var valPaypalEmail = fundraiserSettings.campaigns[fundraiserSettings.campaigns.length -1].paypal.paypalcredentials.production_email
        var valSelectOptions=""
        var valHiddenOptions=""


        fundraiserSettings.campaigns[fundraiserSettings.campaigns.length -1].paypal.billplans.forEach((bp, bpind)=>{


            
            valSelectOptions=valSelectOptions + `<option value="$${bp.planamount}">$${bp.planamount} monthly</option>`
            valHiddenOptions = valHiddenOptions + `
                <input type="hidden" name="option_select${bpind}" value="$${bp.planamount}">
                <input type="hidden" name="option_amount${bpind}" value="${Number(bp.planamount).toFixed(2)}">
                <input type="hidden" name="option_period${bpind}" value="M">
                <input type="hidden" name="option_frequency${bpind}" value="1">
            `
        })
        

        
        if(this.isStaging){
            valPaypalFormAction = "https://www.sandbox.paypal.com/cgi-bin/webscr" 
            valPaypalEmail = fundraiserSettings.campaigns[fundraiserSettings.campaigns.length -1].paypal.paypalcredentials.sandbox_email
        }


        var btn = `
            <form action="${valPaypalFormAction}" method="post" target="_top">
            <input type="hidden" name="cmd" value="_xclick-subscriptions">
            <input type="hidden" name="business" value="${valPaypalEmail}">
            <input type="hidden" name="lc" value="US">
            <input type='hidden' name='custom' value="${description}">
            <input type="hidden" name="item_name" value="${fundraiserSettings.fundraisertitle}">
            <input type="hidden" name="item_number" value="${fundraiserSettings.fundraiserid}">
            <input type="hidden" name="no_note" value="1">
            <input type="hidden" name="no_shipping" value="1">
            <input type="hidden" name="src" value="1">            
            <input type="hidden" name="currency_code" value="USD">
            <input type="hidden" name="return" value="${returnurl}">
            <input type="hidden" name="bn" value="PP-SubscriptionsBF:btn_subscribeCC_LG.gif:NonHosted">
            <table>
            <tr><td><input type="hidden" name="on0" value="Subscribe Now to Contribute to: ${fundraiserSettings.fundraisertitle}"><b>Subscribe Now!...</b> to Contribute to:<br/> ${fundraiserSettings.fundraisertitle}</td></tr><tr><td>
            <select name="os0" class="paypaldropdown">
                ${valSelectOptions}
            </select> </td></tr>
            </table>
            ${valHiddenOptions}
            <input type="hidden" name="option_index" value="0">
            <input type='hidden' name='notify_url' value='${valNotifyUrl}'>
            

            <input type="image" src="https://www.paypalobjects.com/en_US/i/btn/btn_subscribeCC_LG.gif" border="0" name="submit" alt="PayPal - The safer, easier way to pay online!">
            <img alt="" border="0" src="https://www.paypalobjects.com/en_US/i/scr/pixel.gif" width="1" height="1">
            </form>
        `; 
        return btn         
      }          
    },
    watch:{

    },
    methods:{   
            
        subscribeToPlan(paypalConfiguration, billplanid, billplanname){

            var billingPlan = billplanid;
            var billingPlanName = billplanname
            var billingAgreementAttributes;
            var isoDate = new Date();

            var descrObj = new Object()
            descrObj.userid=this.member.userid
            descrObj.firstname=this.member.firstname
            descrObj.lastname=this.member.lastname
            descrObj.fundraiserid = this.fundraiserid

            isoDate.setSeconds(isoDate.getSeconds() + 4);
            isoDate.toISOString().slice(0, 19) + 'Z';

            billingAgreementAttributes = {
                name: billingPlanName,
                description: JSON.stringify(descrObj),
                start_date: isoDate,
                plan: {
                    id: billingPlan
                },
                payer: {
                    payment_method: 'paypal'
                }
            }

var paypal = require('paypal-rest-sdk');
            paypal.configure(paypalConfiguration)

            paypal.billingAgreement.create(billingAgreementAttributes, function (error, billingAgreement) {
                    if (error) {
                        console.log(error);
                        throw error;
                    } else {
                        console.log("Create Billing Agreement Response");
                        //console.log(billingAgreement);
                        for (var index = 0; index < billingAgreement.links.length; index++) {
                            if (billingAgreement.links[index].rel === 'approval_url') {
                                var approval_url = billingAgreement.links[index].href;
                                console.log("For approving subscription via Paypal, first redirect user to");
                                console.log(approval_url);

                                console.log("Payment token is");
                                console.log(url.parse(approval_url, true).query.token);
                                // See billing_agreements/execute.js to see example for executing agreement 
                                // after you have payment token

                                var paymentToken = url.parse(approval_url, true).query.token;

                                //Retrieve payment token appended as a parameter to the redirect_url specified in
                                //billing plan was created. It could also be saved in the user session
                                //paymentToken = 'EC-2V0782854X675410W';

                                paypal.billingAgreement.execute(paymentToken, {}, function (error, billingAgreement) {
                                    if (error) {
                                        console.log(error);
                                        throw error;
                                    } else {
                                        console.log("Billing Agreement Execute Response");
                                        console.log(JSON.stringify(billingAgreement));
                                    }
                                });                                

                            }
                        }
                    }
                });
         
        }
    }
  }
</script>

<style>
.flexlabel{
    font-weight: bold;

}
.paypaldropdown{

  width: 250px;
font-weight:bold;
  font-size: 16px;
  border: 1px solid #ccc;
  height: 34px;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;

  background-image:
    linear-gradient(45deg, transparent 50%, gray 50%),
    linear-gradient(135deg, gray 50%, transparent 50%),
    radial-gradient(#ddd 70%, transparent 72%);
  background-position:
    calc(100% - 20px) calc(1em + 2px),
    calc(100% - 15px) calc(1em + 2px),
    calc(100% - .5em) .5em;
  background-size:
    5px 5px,
    5px 5px,
    1.5em 1.5em;
  background-repeat: no-repeat;


}
</style>